import { format } from "date-fns";
import { es } from "date-fns/locale/es";

/** Lista de "yyyy-MM" desde `from` hasta `to`, inclusive. Si vienen invertidos, se corrige. */
export function enumerateMonths(from: string, to: string): string[] {
  let [fy, fm] = from.split("-").map(Number);
  let [ty, tm] = to.split("-").map(Number);
  if (fy > ty || (fy === ty && fm > tm)) {
    [fy, fm, ty, tm] = [ty, tm, fy, fm];
  }
  const months: string[] = [];
  let y = fy;
  let m = fm;
  while (y < ty || (y === ty && m <= tm)) {
    months.push(`${y}-${String(m).padStart(2, "0")}`);
    m += 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
  }
  return months;
}

/** Etiqueta corta en español para un "yyyy-MM", ej. "abr 2026". */
export function formatMonthLabel(month: string): string {
  const [y, m] = month.split("-").map(Number);
  return format(new Date(Date.UTC(y, m - 1, 1)), "MMM yyyy", { locale: es });
}
